import { render } from "./FloatingMenu.vue?vue&type=template&id=4d8cbe88&ts=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=ts"
export * from "./FloatingMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__